"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringDateTime = exports.isPresent = void 0;
exports.assertUnreachable = assertUnreachable;
const zod_1 = require("zod");
const isPresent = (value) => value !== null && value !== undefined && value !== "";
exports.isPresent = isPresent;
function assertUnreachable(_x) {
    throw new Error("Didn't expect to get here");
}
exports.stringDateTime = zod_1.z.iso.datetime({ offset: true }).nullish();
